// extracted by mini-css-extract-plugin
export default {"panel":"SettingsPanel_panel__5eVj-","iconButton":"SettingsPanel_iconButton__5Xvqm"};